import React from 'react'
import Nav from '../Components/Nav'
import Footer from '../Components/Footer'
import GetAppMain from '../Components/GetAppMain'
import GoToTop from '../Components/GoToTop'

const GetApp = () => {
  return (
    <>
    <Nav/>
    <GetAppMain/>
    <Footer/>
    <GoToTop/>
    </>
  )
}

export default GetApp